import React from "react";

import * as v3dAppAPI from './v3dApp/app';
import './v3dApp/app.css';
import './style.scss';

class V3DApp extends React.Component<any, any> {
    // @ts-ignore
    #app: any = null;

    firstTime = true;
    private readonly container: React.RefObject<HTMLDivElement>;

    constructor(props: any) {
        super(props);
        this.container = React.createRef();
    }

    componentDidMount() {
        if (this.firstTime) {
            this.firstTime = false;
            v3dAppAPI.createApp()!.then(app => {
                this.#app = app;
            });
        }
    }

    componentWillUnmount() {
        if (this.#app !== null) {
            this.#app.dispose();
            this.#app = null;
        }
    }

    render() {
        return (
            <div id={v3dAppAPI.CONTAINER_ID} ref={this.container}>
                <div id="fullscreen_button" className="fullscreen-button fullscreen-open"
                     title="Toggle fullscreen mode">
                </div>
            </div>
        )
    }
}

export default V3DApp
